import { TitleActionType, UserTitleRole } from '../enums';
import { Request, LocalStorage } from '../utils';
import { dispatch, getState, TitleState } from '../reducers';

export const getTitle = (): void => {
    const { title } = LocalStorage.get();
    dispatch({
        type: TitleActionType.Update,
        payload: { selectedTitle: title },
    });
};

export const setTitle = (title: Entities.UserTitleData): void => {
    LocalStorage.set('title', title);
    dispatch({
        type: TitleActionType.Update,
        payload: { selectedTitle: title },
    });
};

export const resetTitle = (): void => {
    const title: Entities.UserTitleData = {
        id: '',
        name: '',
        created: 0,
        updated: 0,
        imageUrl: '',
        organization: '',
        apiUrl: '',
        apiSecretKey: '',
        userTitleRole: 0,
        analyticsEnable: false,
    };
    LocalStorage.set('title', title);
    dispatch({ type: TitleActionType.Reset });
};

export const list = async (): Promise<void> => {
    const titles: Entities.UserTitleData[] | null = await Request.get('title/list', undefined, undefined, false);
    if (!titles) {
        return;
    }
    dispatch({
        type: TitleActionType.Update,
        payload: { titles },
    });
};

export const create = async (name: string, apiUrl: string, apiSecretKey: string): Promise<void> => {
    const title: Entities.UserTitleData | null= await Request.post('title/create', {name, apiUrl, apiSecretKey}, undefined, false);
    if (!title) {
        return;
    }
    const state: TitleState = getState().title;
    const oldTitle = state.titles ? state.titles : [];
    const titles = [...oldTitle , title];
    dispatch({
        type: TitleActionType.Update,
        payload: { titles },
    });
};

export const update = async (titleId: string, name: string, apiUrl: string, apiSecretKey: string, analyticsEnable: boolean, file: any): Promise<void> => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("apiUrl", apiUrl);
    formData.append("apiSecretKey", apiSecretKey);
    formData.append("analyticsEnable", analyticsEnable.toString());
    formData.append("file", file);
    const title = await Request.postForm(`title/${titleId}/update`, formData, false);
    const state: TitleState = getState().title;
    const titles: Entities.UserTitleData[] = state.titles ? state.titles.map((t: Entities.UserTitleData) => (t.id === titleId) ? title : t) : [title];
    dispatch({
        type: TitleActionType.Update,
        payload: { titles },
    });
};

export const deleteTitle = async(titleId: string): Promise<void> => {
    await Request.post(`title/${titleId}/delete`, undefined, undefined, false);
    resetTitle();
};

export const getConfig = async (): Promise<void> => {
    const config = await Request.get(`titleConfig/get`);
    dispatch({
        type: TitleActionType.Update,
        payload: config,
    });
};

export const addTitleUser = async (titleId: string, username: string, role: UserTitleRole): Promise<void> => {
    await Request.post(`title/${titleId}/addUser`, { username, role }, undefined, false);
};

export const deleteTitleUser = async (titleId: string, username: string): Promise<void> => {
    await Request.post(`title/${titleId}/deleteUser`, { username }, undefined, false);
};

export const editTitleUser = async (titleId: string, username: string, role: UserTitleRole): Promise<void> => {
    await Request.post(`title/${titleId}/editUser`, { username, role }, undefined, false);
};
